import {
  presentEnvironmentRecovery,
  type EnvironmentConnectionPresentation,
} from "@afar-research/client-runtime/state/presentation";

import { ENVIRONMENT_RECOVERY_LABELS } from "./settings/environmentAccessRecovery";
import { Button } from "./ui/button";

/**
 * The one control that offers an unreachable Environment a way back, wherever a surface
 * reports one. What the control says and whether pressing it helps are decided by the
 * connection alone, so a banner and an empty state cannot drift into offering different
 * recoveries for the same failure.
 */
export function EnvironmentRecoveryButton(props: {
  readonly connection: EnvironmentConnectionPresentation;
  readonly size?: "xs" | "sm";
  readonly onRetry: () => void;
  readonly onOpenConnectionSettings: () => void;
}) {
  const recovery = presentEnvironmentRecovery(props.connection);
  const recoveryAction = props.connection.recoveryAction;
  return (
    <Button
      size={props.size ?? "sm"}
      disabled={recovery.isRecovering}
      onClick={() => {
        if (recovery.retriesInPlace) {
          props.onRetry();
        } else {
          props.onOpenConnectionSettings();
        }
      }}
    >
      {recovery.isRecovering
        ? "Reconnecting..."
        : recoveryAction === null
          ? "Retry"
          : ENVIRONMENT_RECOVERY_LABELS[recoveryAction]}
    </Button>
  );
}
